export default __webpack_public_path__ + "static/media/paternity-min.eb5be74a.png";